// extracted by mini-css-extract-plugin
export default {"items":"HolidaysInfo_items__JEHYD"};